module.exports = __webpack_public_path__ + "static/media/flower-daffodil.30dd5d67.svg";